import IconPlus from '@persona-id/design-tokens/icons/PlusIcon';

import IntegrationHeroCard from 'dashboard/components/IntegrationHeroCard';
import ModalWrapper from 'dashboard/components/ModalWrapper';
import FormExternalIntegrationAddApiKey from 'dashboard/forms/FormExternalIntegrationAddApiKey';
import { Container, Section } from 'dashboard/layouts/IndexViewLayoutV2';
import { ExternalIntegration } from 'dashboard/models/external-integration';
import { CreateExternalIntegrationParams } from 'dashboard/redux/thunk-actions/external-integrations';
import ApiKeysTable from 'dashboard/views/DashboardExternalIntegrationsShowView/ApiKeysTable';
import ExternalIntegrationHeader from 'dashboard/views/DashboardExternalIntegrationsShowView/ExternalIntegrationHeader';
import { ProductFeatureContactUsBanner } from 'dashboard/views/DashboardExternalIntegrationsShowView/ProductFeatureContactUsBanner';
import Button from 'design-system/components/Button';
import Card from 'design-system/components/Card';
import {
  LEGACY_EXTERNAL_INTEGRATION_VENDOR_ICON,
  LegacyExternalIntegrationVendor,
} from 'lib/constants/externalIntegrationVendors';
import useToggle from 'lib/hooks/useToggle';

interface ExternalIntegrationConfigurationProps {
  editable: boolean;
  isLoading: boolean;
  externalIntegrations: ExternalIntegration[];
  externalIntegrationVendor: LegacyExternalIntegrationVendor;
  createExternalIntegration: (
    externalIntegrationType: ExternalIntegration['type'],
    integrationParams: CreateExternalIntegrationParams,
  ) => void;
  setSelectedIntegration: (integration: ExternalIntegration) => void;
}

const ExternalIntegrationConfiguration = ({
  editable,
  isLoading,
  externalIntegrations,
  externalIntegrationVendor,
  createExternalIntegration,
  setSelectedIntegration,
}: ExternalIntegrationConfigurationProps) => {
  const [showAddApiKeyModal, { enable: openAddApiKeyModal, disable: closeAddApiKeyModal }] =
    useToggle(false);

  return (
    <>
      <ModalWrapper isOpen={showAddApiKeyModal} handleCloseModal={closeAddApiKeyModal}>
        <FormExternalIntegrationAddApiKey
          externalIntegrationVendor={externalIntegrationVendor}
          createExternalIntegration={createExternalIntegration}
          handleClose={closeAddApiKeyModal}
        />
      </ModalWrapper>
      <Container>
        <ExternalIntegrationHeader editable={editable}>
          <Button
            id='external-integration-configuration__add-api-key-button'
            width='auto'
            prefixIcon={<IconPlus />}
            disabled={!editable}
            aria-label='modal add button'
            onClick={openAddApiKeyModal}
          >
            Add API Key
          </Button>
        </ExternalIntegrationHeader>
        <Section>
          <ProductFeatureContactUsBanner />
          <IntegrationHeroCard
            title={externalIntegrationVendor['display-name']}
            image={LEGACY_EXTERNAL_INTEGRATION_VENDOR_ICON(externalIntegrationVendor)}
          >
            {externalIntegrationVendor.description}
          </IntegrationHeroCard>
          <Card>
            <Card.Body>
              <ApiKeysTable
                editable={editable}
                isLoading={isLoading}
                externalIntegrations={externalIntegrations}
                externalIntegrationVendor={externalIntegrationVendor}
                setSelectedIntegration={setSelectedIntegration}
              />
            </Card.Body>
          </Card>
        </Section>
      </Container>
    </>
  );
};

export default ExternalIntegrationConfiguration;
